import React, { useRef } from 'react';
import { Stack, Row, Col } from 'react-bootstrap';
import { LomavisDownloadDomElementButton } from '@/lomavisSharedUi/atoms/buttons/LomavisDownloadDomElementButton';

interface LomavisTitleProps {
  title: string;
}

const LomavisLayout1Title: React.FC<LomavisTitleProps> = ({ title }) => {
  return title ? (
    <div className="h5 fw-bold text-muted mb-2 bg-white">{title}</div>
  ) : null;
};

interface LomavisLayout1Props {
  title: string;
  subTitle?: string; // Optional subtitle
  topLeftTitle?: string; // Optional title for topLeft component
  topRightTitle?: string; // Optional title for topRight component
  topLeft: React.ReactNode;
  topRight: React.ReactNode;
  bottom: React.ReactNode;
  topRowClassName?: string; // Optional className for the top row, can be used to set height to 0px if no data
}

export const LomavisLayout1: React.FC<LomavisLayout1Props> = ({
  title,
  subTitle,
  topLeftTitle,
  topRightTitle,
  topLeft,
  topRight,
  bottom,
  topRowClassName = 'h-400px mb-3 bg-white'
}) => {
  const cardRef = useRef<HTMLDivElement>(null);

  return (
    <div className="position-relative">
      <div ref={cardRef} className="card bg-white shadow-sm rounded-3 p-4">
        <Stack gap={3} className={'bg-white'}>
          <div
            className={
              'd-flex flex-row justify-content-between align-items-center bg-white'
            }
          >
            <div className="h2 fw-bold bg-white">{title}</div>
            <div className={'d-flex flex-row bg-white'}>
              {subTitle && <div className={'text-muted'}>{subTitle}</div>}
              <div className="top-0 end-0 mt-n3 me-n4 ms-2 z-1 bg-white">
                <LomavisDownloadDomElementButton elementRef={cardRef} />
              </div>
            </div>
          </div>

          <Row className={topRowClassName}>
            <Col>
              <LomavisLayout1Title title={topLeftTitle} />
              {topLeft}
            </Col>
            <Col className="d-flex flex-column">
              <LomavisLayout1Title title={topRightTitle} />
              {topRight}
            </Col>
          </Row>

          <Row>
            <Col>{bottom}</Col>
          </Row>
        </Stack>
      </div>
    </div>
  );
};
